import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router';
import { combineLatest, Observable, of } from 'rxjs';
import { CrmInjectionToken, PAGE_ROUTES } from '@galaxy/crm/static';
import { map, switchMap } from 'rxjs/operators';
import { ViewAccessApiService } from '@vendasta/platform-users';

@Injectable({ providedIn: 'root' })
export class AccessGuard {
  private readonly config = inject(CrmInjectionToken);
  private readonly router = inject(Router);
  private readonly viewAccessService = inject(ViewAccessApiService);

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
    const view = route.data['view'] as string;
    return combineLatest([this.config.namespace$, this.config.parentNamespace$]).pipe(
      switchMap(([namespace, parentNamespace]) => {
        return this.viewAccessService.hasViewAccess({
          viewIds: [view],
          partnerId: parentNamespace || namespace,
        });
      }),
      switchMap((response) => {
        const hasAccess = response.access[0].hasAccess;
        return hasAccess ? of(true) : this.getPermissionRequiredUrl$();
      }),
    );
  }

  getPermissionRequiredUrl$(): Observable<UrlTree> {
    return this.config.routePrefix$.pipe(
      map((routePrefix) => this.router.createUrlTree([`${routePrefix}/${PAGE_ROUTES.PERMISSION_REQUIRED}`])),
    );
  }
}
